let cachedIp: string | null = null;

export const getClientIp = async (): Promise<string> => {
  if (cachedIp) return cachedIp;
 
  const localIp = localStorage.getItem("user_ip");
  if (localIp) {
    cachedIp = localIp;
    return cachedIp;
  }
 
  try {
    const res = await fetch("https://api.ipify.org?format=json", {
      signal: AbortSignal.timeout(3000) // Add timeout
    });
    if (!res.ok) throw new Error('IP fetch failed');
    const data = await res.json();
    cachedIp = data.ip;
    localStorage.setItem("user_ip", cachedIp);
    return cachedIp;
  } catch (err) {
    // Silently fail - ad blockers will block this
    // Only log in development
    if (process.env.NODE_ENV === 'development') {
      console.warn("IP fetch blocked (likely by ad blocker):", err);
    }
    return "";
  }
};
